import React, { useEffect, useState, useRef, useCallback  } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { debounce } from "lodash";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';

import TobNavBar from "../../DashBaord/Top_navbar";
import ShowData from "../../../components/ShowData";
import { Link, useNavigate } from "react-router-dom";

import moment from "moment";
import SkeltonList from "../../../components/SkeltonEffect/list";
import { list } from "../../../controllers/V1/activeLogs/activeLogsController";
import { formatProjectDate } from "../../../controllers/common";
import Details from "./Details";
function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  /************************************************************************************* */
  const ADMINUSER = JSON.parse(localStorage.getItem("ADMIN-INFO"));
  const [isLoading, setIsLoading] =useState(false);
  const targetRef = useRef(null);
  const [ALLLISTDATA, setListData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState(ALLLISTDATA);
  const [date, setDate] = useState(moment().format('YYYY-MM-DD'));
  const handleDateChange = (e) =>{
    try {
      setDate(e.target.value);
    } catch (error) {
      
    }
  }
  const [details, setDetails] = useState('');
  const [showDetails, setShowDetails] = useState(false);
  const togglePopUp = () => setShowDetails(!showDetails);

  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const options = { date : date };
      const listData = await list(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          if(ADMINUSER?.admin_type !== 'Super Admin'){
            const data = listData.result?.filter((items) =>
              !items?.output?.toLowerCase().includes('info@alldaydiscount.com')
            );
            setListData(data?.reverse());
          } else{
            setListData(listData?.result?.reverse());
          }
          setIsLoading(false);
        } else {
          setListData([]);
          setIsLoading(false);
        }
      } else {
        setListData([]);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  }; //End

  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
      getList();
    targetRef.current.scrollIntoView({
      behavior:'smooth',
    });
    document.title = "Orbit Kuwait || Active Logs";
  }, [date]);

  const handleSearch = useCallback(
    debounce((query) => {
      if (!query) {
        setFilteredData(ALLLISTDATA);
      } else {
        setFilteredData(
          ALLLISTDATA?.filter((items) =>
            items?.output?.toLowerCase().includes(query.toLowerCase())
          )
        );
      }
    }, 600), 
    [ALLLISTDATA]
  );

  useEffect(() => {
    handleSearch(searchQuery);
    return () => handleSearch.cancel();
  }, [searchQuery, handleSearch]);


  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Active Logs"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="all_tabs_value">
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    className="item_tabs_main_container"
                  >
                    <Tab
                      label="All"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => setDate(moment().format('YYYY-MM-DD'))}
                    />
                  </Tabs>
                </div>

                <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                  <div className="inventory_filter_div">
                    <input type="date" name="date" id="date" value={date} onChange={handleDateChange} className="form-control" />
                  </div>
                </div>
              </div>
            </Box>
            <br/>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <input name="search" id="search" className="form-control"  placeholder="Search active logs"  onChange={(e) => setSearchQuery(e.target.value)} />
              </div>
            </Box>            
            <VendorList 
              >
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      <div className="table-responsive">
                        <table
                          className="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellspacing="0"
                        >
                          <thead>
                            <tr>
                              <th>Sl. No.</th>
                              <th>Logs</th>
                              <th>Created Date & Time</th>
                              <th>Details</th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredData?.length > 0 ? (
                              filteredData.map((items, index) => (
                                <>
                                  <tr key={index} >
                                    <td>{ index + 1}</td>
                                    <td>{items?.output}</td>
                                    {/* <td>{moment(items?.timestamp).add(3, 'hours').format('DD-MM-YYYY hh:mm A')}</td> */}
                                    <td>{moment(formatProjectDate(items?.timestamp)).format('DD-MM-YYYY HH:mm')}</td>
                                    <td onClick={()=>{ setDetails(items?.payload || 'N/A'); togglePopUp(); }}>
                                        <Link to={false} ><FontAwesomeIcon icon={faEye} />View</Link>
                                    </td>
                                  </tr>
                                </>
                              ))
                            ) : isLoading ? <SkeltonList row={5} col={4} /> : <tr> 
                                <td colspan="4" className="img-center" >No data found !</td> 
                            </tr>}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
      <Details popUpOpen={showDetails} togglePopUp={togglePopUp} details={details || ''}  />
    </>
  );
}
